import { useSelector } from 'react-redux'
import { ROLES } from 'features/Permission'
import { getUser } from 'redux/store/user/getters'
import { EditCommunityDetails } from './EditCommunityDetails/EditCommunityDetails'
import { CommunityDetails } from './CommunityDetails'
import { CommunityData } from 'features/MyCommunity/Communities/CommunityDetails/types'
import { mapCommunityDetailsToForm } from '../helpers'

export const CommunityDetailsContainer = ({
  communityData
}: {
  communityData: CommunityData | null
}) => {
  const user = useSelector(getUser)

  if (!communityData) return null

  if (user.role === ROLES.COMMUNITY_PRESIDENT) {
    const communityDetailsMappedData = mapCommunityDetailsToForm(communityData)
    return <EditCommunityDetails communityData={communityDetailsMappedData} />
  }

  return <CommunityDetails communityData={communityData} />
}
